var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 .7v2.8a.7.7 0 11-1.4 0V1.4H7.7v11.2h2.1a.7.7 0 110 1.4H4.2a.7.7 0 110-1.4h2.1V1.4H1.4v2.1a.7.7 0 11-1.4 0V.7A.7.7 0 01.7 0h12.6a.7.7 0 01.7.7z"
  })));
}
export default SvgText;